export default __webpack_public_path__ + "static/media/Blossom-Cake.36d6feb3.jpg";